module.exports = {
  throwError: message => {
    throw new Error(message);
  },
  getExperiment: (experimentSummaries, experimentName) =>
    experimentSummaries.experimentAdds.find(
      item => item.name === experimentName
    ),
  getGoal: (experimentSummaries, goalName) =>
    experimentSummaries.goalAdds[goalName]
};



// WEBPACK FOOTER //
// ./src/ab-helpers.js